import { useQuery } from '@tanstack/react-query';
import { fetchDealerStatuses } from '../services/dealers';

export const dealerStatusKeys = {
    all: ['dealer-statuses'] as const,
};

export const useDealerStatusesQuery = () => {
    return useQuery({
        queryKey: dealerStatusKeys.all,
        queryFn: fetchDealerStatuses,
        staleTime: 30 * 60 * 1000,
    });
};
